import { Check, Clear, Remove } from '@mui/icons-material';
import { Avatar, ListItem, Typography, useTheme } from '@mui/material';
import { type FC, useState } from 'react';
import type { HygieneItemType, HygieneRoomType, HygieneStatusRoomType } from '../../../models';
import { extractHygieneColors } from '../../../utils';
import { LightboxGallery } from '../../Dialogs';

export interface AvaniHygieneBarCardProps {
  room: HygieneStatusRoomType;
  roomType: HygieneRoomType;
  category: HygieneItemType;
  index: number;
}

export const AvaniHygieneBarCard: FC<AvaniHygieneBarCardProps> = ({ room, roomType, category, index }) => {
  const { roomName, hygieneStatus, media } = room;
  const theme = useTheme();
  const id = `${roomType}s ${category} ${index}`;

  const { color, bg } = extractHygieneColors(hygieneStatus, theme);
  // Decorate avatars with outline, which have media
  const hasMedia = !!media.length;
  const [toggle, setToggle] = useState(false);
  const handleClose = () => {
    setToggle(false);
  };

  return (
    <ListItem
      disablePadding
      id={id}
      key={index}
      onClick={() => setToggle(true)}
      sx={{
        cursor: hasMedia ? 'pointer' : '',
        display: 'block',
        width: 'auto',
        minWidth: '80px',
        float: 'left',
        padding: '0 12px 0 0',
        minHeight: '60px'
      }}
    >
      <Avatar
        sx={{
          margin: '0 auto',
          backgroundColor: bg,
          border: hasMedia ? `2px solid ${theme.colors.avani.teal}` : ''
        }}
      >
        {hygieneStatus === null ? (
          <Remove sx={{ fill: color }} />
        ) : hygieneStatus ? (
          <Check sx={{ fill: color }} />
        ) : (
          <Clear sx={{ fill: color }} />
        )}
      </Avatar>
      <Typography variant={'body2'} color={color} sx={{ width: '100%', textAlign: 'center' }}>
        {roomName ?? 'N/a'}
      </Typography>
      {hasMedia && <LightboxGallery open={toggle} index={0} handleClose={handleClose} imageSrc={media} theme={theme} />}
    </ListItem>
  );
};
